import useDocumentCreator from "../../../engine/hooks/useDocumentCreator";
import dayjs from "../../../utils/dayjs";
import {
  daysJsFormat,
  languagesList,
  renderStatusLabels,
  renderTypePrestation,
  renderUserName,
} from "../../../utils/constants";
import { Excel } from "antd-table-saveas-excel";
import { Button, Space } from "antd";
import { AiFillFileExcel } from "react-icons/ai";
import React from "react";
import { useSelector } from "react-redux";
import { FilePdfOutlined } from "@ant-design/icons";
import { createXMLString, downloadXML } from "../../../utils/bills.xml";
import { http } from "../../../engine/api/http";
import { BsFiletypeXml } from "react-icons/bs";
import { TbFileTypeXml } from "react-icons/tb";

export const BillsExportFile = ({ type, selectedRowKeys }) => {
  const { bills } = useSelector(state => state.billing);
  const [get, createAndGet, isLoading, setUrl, doc] = useDocumentCreator();

  const exportPDF = () => {
    createAndGet({ ids: selectedRowKeys }, `bills/pdfs`, true, true, () => {
      console.log("done download");
    });
  };
  const exportXML = async () => {
    try {
      const loggit = await http.post("/logs", {
        baseUrl: "/api/bills",
        action: "export",
        route: "/api/bills/xml",
        ressource: "/api/bills/xml",
        content: {
          billsId: selectedRowKeys,
        },
      });


      const toExport = bills.filter(e => {
        return selectedRowKeys.includes(e._id);
      });
      //
      // let prestationsId = [];
      //
      // toExport.map(e => {
      //   e.prestations.map(p => {
      //     if (!prestationsId.includes(p._id)) {
      //       prestationsId.push(p._id);
      //     }
      //   });
      // });
      //
      // const getShortDataPrestations = await http.post("/prestations/short", {
      //   prestationsId,
      // });

      const xmlString = createXMLString({
        bills: toExport,
        // prestations: getShortDataPrestations.data,
      });
      downloadXML(xmlString, "bills.xml");
    } catch (e) {
      console.log(e);
    }
  };

  const exportExcel = async () => {
    const loggit = await http.post("/logs", {
      baseUrl: "/api/bills",
      action: "export",
      route: "/api/bills/xlxs",
      ressource: "/api/bills/xlxs",
      content: {
        billsId: selectedRowKeys,
      },
    });
    const exportColumns = [
      {
        title: "Numéro prestation",
        dataIndex: "prestationRef",
      },
      {
        title: "Numéro facture",
        dataIndex: "bill_number",
      },
      {
        title: "Référence",
        dataIndex: "reference",
      },
      {
        title: "Status de la prestation",
        dataIndex: "status",
      },
      {
        title: "Interprète",
        dataIndex: "interprete",
      },
      {
        title: "Id Interprète",
        dataIndex: "interpreteId",
      },
      {
        title: "Langue",
        dataIndex: "langue",
      },
      {
        title: "Total Hors TVA",
        dataIndex: "totalHorsTva",
      },
      {
        title: "Cout de la prestation (par tranches)",
        dataIndex: "coutPrestation",
      },
      {
        title: "Tranches de la prestation",
        dataIndex: "tranchesPrestation",
      },
      {
        title: "Tranches de la prestation de nuit",
        dataIndex: "tranchesPrestationNight",
      },
      {
        title: "Cout de nuit de la prestation (par tranches)",
        dataIndex: "coutNight",
      },
      {
        title: "Cout de déplacement",
        dataIndex: "coutTravel",
      },
      {
        title: "Kms",
        dataIndex: "kms",
      },
      {
        title: "Total TTC",
        dataIndex: "totalTTC",
      },
      {
        title: "TVA",
        dataIndex: "tvaAmount",
      },

      {
        title: "Cents correction",
        dataIndex: "ctsCorrection",
      },
      {
        title: "Date de début",
        dataIndex: "startDate",
      },
      {
        title: "Date de fin",
        dataIndex: "endDate",
      },
      {
        title: "Lieu de départ",
        dataIndex: "locationFrom",
      },
      {
        title: "Lieu de l'intervention",
        dataIndex: "location",
      },
      {
        title: "Type de prestation",
        dataIndex: "typePrestation",
      },
      {
        title: "Institution",
        dataIndex: "institution",
      },
      {
        title: "Hors Canton",
        dataIndex: "horsCanton",
      },
      {
        title: "Urgent",
        dataIndex: "urgent",
      },
    ];

    function metersToKilometers(meters) {
      const kilometers = meters / 1000;
      return `${kilometers.toFixed(1)}`;
    }

    const findPresta = (arr, key) => {
      return arr.find(e => e.type === key);
    };

    const mutateData = () => {
      let newArr = [];

      bills
        .filter(e => {
          return selectedRowKeys.includes(e._id);
        })
        .map(bill => {
          const { costParams, costs } = bill;
          bill.prestations.map(presta => {
            let amounts = {
              totalHorsTva: 0,
              totalTTC: 0,
              tvaAmount: 0,
              totalNonAssujeti: 0,
              kms: 0,
              ctsCorrection: 0,
              horsCanton: false,
              urgent: false,
              coutPrestation: 0,
              coutNight: 0,
              coutTravel: 0,
            };
            if (bill.institution.groupedBilling) {
              let ref = bill.costsMultiple.find(
                e => e.prestationId === presta._id,
              );

              if (ref !== undefined) {
                amounts.tvaAmount = costParams.tvaAmount;
                amounts.totalHorsTva = costParams.totalHorsTva;
                amounts.totalTTC = costParams.totalWithTva;

                amounts.totalHorsTva = ref.costParams.total;
                amounts.kms = metersToKilometers(
                  ref?.costParams?.driving?.distance?.value || 0,
                );

                amounts.horsCanton = ref.costParams.isHorsCanton;
                amounts.urgent = ref.costParams.isUrgent;
                amounts.coutPrestation =
                  findPresta(ref.cost, "prestation")?.amount || 0;
                amounts.coutNight = findPresta(ref.cost, "night")?.amount || 0;
                amounts.coutTravel =
                  findPresta(ref.cost, "travel")?.amount || 0;
                amounts.tranchesPrestation =
                  findPresta(ref.cost, "prestation")?.tranches || 0;
                amounts.tranchesPrestationNight =
                  findPresta(ref.cost, "night")?.tranches || 0;
              }
            } else {
              amounts.totalHorsTva = costParams.total;
              amounts.totalTTC = costParams.totalWithTva;
              amounts.tvaAmount = costParams.tvaAmount;
              // amounts.totalNonAssujeti = costParams.;
              amounts.kms = metersToKilometers(
                costParams?.driving?.distance?.value || 0,
              );
              amounts.ctsCorrection = costParams.roundCorrection;
              amounts.horsCanton = costParams.isHorsCanton;
              amounts.urgent = costParams.isUrgent;
              amounts.coutPrestation =
                findPresta(costs, "prestation")?.amount || 0;
              amounts.coutNight = findPresta(costs, "night")?.amount || 0;
              amounts.coutTravel = findPresta(costs, "travel")?.amount || 0;
              amounts.tranchesPrestation =
                findPresta(costs, "prestation")?.tranches || 0;
              amounts.tranchesPrestationNight =
                findPresta(costs, "night")?.tranches || 0;
            }

            let dates = {
              startDate: null,
              endDate: null,
            };

            let locations = {
              location: "",
              locationFrom: "",
            };

            if (
              presta.interventionFinal.startDate !== null &&
              presta.interventionFinal.endDate !== null
            ) {
              dates.startDate = dayjs(
                presta.interventionFinal.startDate,
              ).format(daysJsFormat.full);
              dates.endDate = dayjs(presta.interventionFinal.endDate).format(
                daysJsFormat.full,
              );
            } else {
              dates.startDate = dayjs(presta.intervention.startDate).format(
                daysJsFormat.full,
              );
              dates.endDate = dayjs(presta.intervention.endDate).format(
                daysJsFormat.full,
              );
            }

            if (
              presta.interventionFinal.location !== null &&
              presta.interventionFinal.location !== ""
            ) {
              locations.location = presta.interventionFinal.location;
            } else {
              locations.location = presta.intervention.location;
            }

            if (
              presta.interventionFinal.locationFrom !== null &&
              presta.interventionFinal.locationFrom !== ""
            ) {
              locations.locationFrom = presta.interventionFinal.locationFrom;
            } else {
              locations.locationFrom = presta.intervention.locationFrom;
            }

            newArr.push({
              langue: presta.language
                .map(p => languagesList.find(e => e.value === p).label)
                .join(" "),
              institution: bill.institution.name,
              status: renderStatusLabels(
                presta.status,
                presta.subStatus,
                presta.isFollow,
              ),
              typePrestation: renderTypePrestation(presta.intervention.type),
              reference: bill.reference,
              bill_number: bill.bill_number,
              prestationRef: presta.reference,
              interprete: renderUserName(presta.interprete),
              interpreteId: presta.interprete._id,
              ...amounts,
              ...dates,
              horsCanton: amounts.horsCanton ? "Oui" : "Non",
              urgent: amounts.urgent ? "Oui" : "Non",
              ...locations,
            });
          });
        });
      return newArr;
    };

    const excel = new Excel();
    excel
      .addSheet("Facturation")
      .addColumns(exportColumns)
      .addDataSource(mutateData())
      .saveAs("facturation.xlsx");
  };

  return (
    <Space>
      <Button
        type="default"
        size="large"
        icon={<AiFillFileExcel />}
        disabled={selectedRowKeys.length === 0}
        onClick={() => exportExcel()}
      >
        Export XLXS
      </Button>
      <Button
        type="default"
        size="large"
        icon={<FilePdfOutlined />}
        loading={isLoading}
        disabled={selectedRowKeys.length === 0}
        onClick={() => exportPDF()}
      >
        Export PDF
      </Button>
      <Button
        type="default"
        size="large"
        icon={<TbFileTypeXml />}
        disabled={selectedRowKeys.length === 0}
        onClick={() => exportXML()}
      >
        Export XML
      </Button>
    </Space>
  );
};
